module.exports = __webpack_public_path__ + "img/liulianggognxian@2x.c0f36712.png";